var _jsxFileName = "/media/data/Sandbox/soapbox-defake/app/soapbox/features/ui/components/column-loading.tsx";
import React from 'react';
import { Card, CardBody, Spinner } from 'soapbox/components/ui';

const ColumnLoading = () => /*#__PURE__*/React.createElement(Card, {
  variant: "rounded",
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 6,
    columnNumber: 3
  }
}, /*#__PURE__*/React.createElement(CardBody, {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 7,
    columnNumber: 5
  }
}, /*#__PURE__*/React.createElement(Spinner, {
  __self: this,
  __source: {
    fileName: _jsxFileName,
    lineNumber: 8,
    columnNumber: 7
  }
})));

export default ColumnLoading;